"use strict";

// video-slide web component
if (!customElements.get("video-slide")) {
  customElements.define(
    "video-slide",
    class VideoSlide extends HTMLElement {
      constructor() {
        super();
        this.videoEl = this.querySelector("video");
        this.playIcon = this.querySelector("[data-play-icon]");
        this.closeIcon = this.querySelector("[data-close-icon]");
        this.videoEl.controls = false;
      }

      connectedCallback() {
        this.videoEl.play();
        this.playIcon.addEventListener("click", this.playVideo);
        this.closeIcon.addEventListener("click", this.closeVideo);
        this.videoEl.addEventListener("ended", this.closeVideo);
      }

      playVideo = () => {
        document
          .querySelectorAll('video-slide[data-playing-status="true"]')
          .forEach((videoSlideEl) => videoSlideEl.closeVideo());

        this.setAttribute("data-playing-status", true);
        this.videoEl.muted = false;
        this.videoEl.loop = false;
        this.videoEl.volume = 1;
        this.videoEl.currentTime = 0;
        // this.videoEl.controls = true;
        this.videoEl.play();
      };

      closeVideo = () => {
        this.setAttribute("data-playing-status", false);
        this.videoEl.muted = true;
        this.videoEl.loop = true;
        this.videoEl.volume = 0;
        // this.videoEl.controls = false;
        this.videoEl.play();
      };
    },
  );
}

if (!customElements.get("swiper-slider")) {
  customElements.define(
    "swiper-slider",
    class SwiperComponent extends HTMLElement {
      constructor() {
        super();
        this.container = this.querySelector("[data-slider-container]");
      }

      async connectedCallback() {
        const module = await import(flu.chunks.swiper);
        const Swiper = module.default || module.Swiper || window.Swiper;
        new Swiper(this.container, {
          loop: false,
          slidesPerView: "auto",
          spaceBetween: 16,
          freeMode: true,
        });
      }
    },
  );
}

// Bacth details
if (!customElements.get("batch-details")) {
  customElements.define(
    "batch-details",
    class BatchDetails extends HTMLElement {
      constructor() {
        super();
        this.searchFormEl = this.querySelector("[data-search-form]"); // search form where search input is
        this.searchInputEl = this.querySelector("[data-search-input]"); // badge id search input
        this.contentBoxEl = this.querySelector("[data-search-results]"); // content box to render search results
        this.searchErrorEl = this.querySelector("[data-search-error]"); // error element
        this.serverErrorEl = this.querySelector("[data-search-server-error]"); // server error element
        this.convertSchemaToHtml = window.convertSchemaToHtml || null;
      }

      async connectedCallback() {
        // assign convertSchemaToHtml
        if (!window.convertSchemaToHtml) {
          const { convertSchemaToHtml } = await import(
            flu.chunks.shopifyRichTextRenderer
          );
          this.convertSchemaToHtml = convertSchemaToHtml;
          window.convertSchemaToHtml = convertSchemaToHtml;
        }

        if (this.searchFormEl && this.searchInputEl) {
          this.init();
        } else {
          console.error("Search form or input not found for batch details");
        }
      }

      async fetchBatchMetaobject(handle) {
        const shopifyDomain = Shopify.shop;
        const storefrontAccessToken = "7eee1d2459823c709db23dce18eb9cfe";
        const returnData = {
          detailsHtml: "",
          shopifyServerError: false,
          notFound: false,
        };

        const query = `#graphql
            query GetMetaobject {
              metaobject(handle: {type: "batch_info", handle: "${handle}"}) {
                field(key: "batch_info") {
                  value
                }
              }
            }
          `;

        try {
          const response = await fetch(
            `https://${shopifyDomain}/api/2025-04/graphql.json`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
              },
              body: JSON.stringify({ query }),
            },
          );

          const result = await response.json();

          // Handle GraphQL errors
          if (result.errors) {
            console.error("GraphQL Errors:", result.errors);
            return { ...returnData, shopifyServerError: true };
          }

          // Handle missing data
          if (!result.data || !result.data.metaobject) {
            console.warn("Metaobject not found or not accessible.");
            return { ...returnData, notFound: true };
          }

          // Success
          const detailsValue = result.data.metaobject.field.value;
          const detailsHtml = this.convertSchemaToHtml(
            JSON.parse(detailsValue),
            { newLineToBreak: true },
          );
          return { ...returnData, detailsHtml };
        } catch (err) {
          // Handle network or unexpected errors
          console.error("Fetch Error:", err);
          return { ...returnData, shopifyServerError: true };
        }
      }

      init() {
        this.searchFormEl.addEventListener("submit", (e) => {
          e.preventDefault();
          this.handleSubmit();
        });
      }

      async handleSubmit() {
        // add loading
        this.classList.add("loading");

        // fetch
        const { detailsHtml, shopifyServerError, notFound } =
          await this.fetchBatchMetaobject(this.searchInputEl.value);

        if (detailsHtml) {
          this.contentBoxEl.innerHTML = detailsHtml;
          this.contentBoxEl.classList.remove("hidden");
          this.contentBoxEl.classList.add("loaded");

          // hide others
          this.searchErrorEl.classList.add("hidden");
          this.serverErrorEl.classList.add("hidden");
        }

        if (shopifyServerError) {
          this.serverErrorEl.classList.remove("hidden");
          // hide others
          this.searchErrorEl.classList.add("hidden");
          this.contentBoxEl.classList.add("hidden");
        }

        if (notFound) {
          this.searchErrorEl.classList.remove("hidden");
          // hide others
          this.serverErrorEl.classList.add("hidden");
          this.contentBoxEl.classList.add("hidden");
        }
        // remove loading
        this.classList.remove("loading");
      }
    },
  );
}

// when variant changes update the data variant attr on main product section.
// this is added so that accordion can be rendred dynamically based on variant.
document.addEventListener("product:variant-change", function (evt) {
  const allProductIdAttributesEl = document.querySelectorAll(
    "[data-current-product-id]",
  );

  if (allProductIdAttributesEl.length > 0) {
    allProductIdAttributesEl.forEach((el) => {
      el.setAttribute("data-current-product-id", evt.detail.variant.id);
    });
  }
});
